import React from "react";
import { BasicStockChart } from "@/components/Charts";
import { BacktestSel, BacktestType } from "@/features/backtest";
import { Options } from "highcharts/highstock";
import { round } from "lodash";
import { TitleCamelCase } from "@/utils/string";
import { useRootSelector } from "@/infrastructure/hooks";
import { Typography } from "antd";
import { oc } from "ts-optchain";

type Props = {
  target: keyof Pick<
    BacktestType.BacktestResult,
    "portfolioCummulativeReturn" | "portfolioRollingSharpe" | "portfolioRollingVolatility"
  >;
  chartType: string;
  isCumReturn: boolean;
};

export default ({ target, chartType, isCumReturn }: Props) => {
  const groupResult = useRootSelector(BacktestSel.groupResult);

  if (oc(groupResult).strategy[target]([]).length === 0)
    return (
      <Typography.Paragraph>
        {TitleCamelCase(target)} is not saved in snapshot. Please rerun the backtest if you wish to see the data
      </Typography.Paragraph>
    );

  return <BasicStockChart height={450} options={createOption()} />;

  function createOption(): Options {
    return {
      rangeSelector: {
        selected: 3
      },

      title: {
        text: ["Sharpe Ratio", "Volatility"].includes(chartType)
          ? `Half-Yearly Rolling ${chartType}`
          : "Cumulative Return"
      },
      legend: {
        enabled: true
      },
      yAxis: [
        {
          title: {
            text: chartType
          }
        }
      ],
      tooltip: {
        split: true
      },
      series: Object.entries(groupResult).map(([k, v]) =>
        v
          ? {
              type: "line",
              name: TitleCamelCase(k),
              data: v[target] ? v[target].map(getData) : []
            }
          : ({} as any)
      )
    };
  }

  function getData(e: BacktestType.TimeValue) {
    return { y: round(isCumReturn ? e.value * 100 : e.value, 2), x: e.datetime };
  }
};
